import React from 'react';
import axiosInstance from '../../axiosConfig';
import LeagueEvents from './LeagueEvents';
import { useDialogStore } from '../../store/dialogStore';

interface SyncPlayerBtnProps {
  id: number;
  name: string;
}

const SyncPlayerBtn: React.FC<SyncPlayerBtnProps> = ({ id, name }) => {
  const openDialog = useDialogStore((state) => state.openDialog);
  const setMousePositionWithScroll = useDialogStore(
    (state) => state.setMousePositionWithScroll,
  );
  const loadLeagueEvents = async (
    anmeldungId: number,
    anzeigename: string,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (!anmeldungId) return;

    const mouseOffset = event.clientY;
    const scrollOffset = window.scrollY;

    if (window.innerHeight > 1200) {
      console.log('Mouse offset', [
        mouseOffset,
        scrollOffset,
        window.innerHeight,
        window.scrollY,
      ]);
      setMousePositionWithScroll(mouseOffset);
    } else {
      setMousePositionWithScroll(0);
    }

    try {
      const response = await axiosInstance.get(
        `/league/event?registrationId=${anmeldungId}`,
      );
      openDialog(
        <>
          <LeagueEvents
            data={{
              registrationId: anmeldungId,
              location: anzeigename,
              ...response.data,
            }}
          />
        </>,
        () => {},
        true,
      );
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };

  return (
    <div
      onClick={(event) => loadLeagueEvents(id, name, event)}
      className="text-[#52A445] flex gap-0.5 items-center cursor-pointer hover:underline"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={3}
        stroke="currentColor"
        className="size-3"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
      PCCADDIE senden
    </div>
  );
};

export default SyncPlayerBtn;
